import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getSPV } from '../api/stoApi';
import { SPV } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const useSPV = (spvId: string | undefined, reset = false) => {
  const [spvs, setSpvs] = useState<SPV | null>(null);
  const load = async (spvId: string) => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getSPV(spvId)).data;
      setSpvs(response.data);
      if (!response?.data?.id) apiErrorHandling(new Error('SPV not found'), 'Error loading SPV');
    } catch (error: any) {
      apiErrorHandling(error, 'Error loading SPV');
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    if (spvId) {
      load(spvId);
    }
  }, [spvId, reset]);

  return spvs;
};
